@if (path && !href) {
  <a
    class="block h-full w-full"
    referrerpolicy="same-origin"
    rel="next"
    target="_self"
    [routerLink]="path"
    [queryParams]="queryParams"
    [replaceUrl]="replaceUrl"
  >
    <ng-container *ngTemplateOutlet="button" />
  </a>
} @else if (href && !path) {
  <a
    class="block h-full w-full"
    data-testid="hrefLink"
    referrerpolicy="same-origin"
    rel="next"
    target="_blank"
    [attr.href]="href"
  >
    <ng-container *ngTemplateOutlet="button" />
  </a>
} @else if (!href && !path) {
  <ng-container *ngTemplateOutlet="button" />
}

<ng-template #button>
  <button
    #nativeBtn
    awRipple
    [ngClass]="{
      'po-button--small text-po-label-small': size === BUTTON_SIZE.Small,
      'po-button--medium text-po-label-medium': size === BUTTON_SIZE.Medium,
      'po-button--large text-po-label-large': size === BUTTON_SIZE.Large,

      'po-button--auth-submit': variant === BUTTON_VARIANT.AuthSubmit,
      'po-button--auth-resend': variant === BUTTON_VARIANT.AuthResend,
      'po-button--auth-submit-blue': variant === BUTTON_VARIANT.AuthSubmitBlue,
      'po-button--auth-resend-blue': variant === BUTTON_VARIANT.AuthResendBlue,
      'po-button--primary': variant === BUTTON_VARIANT.Primary,
      'po-button--primary-outline': variant === BUTTON_VARIANT.PrimaryOutline,
      'po-button--secondary': variant === BUTTON_VARIANT.Secondary,
      'po-button--text': variant === BUTTON_VARIANT.Text,
      'po-button--error-link': variant === BUTTON_VARIANT.ErrorLink,

      'po-button--corporate': businessUnit === BUTTON_BUSINESS_UNIT.Corporate,
      'po-button--mortgage': businessUnit === BUTTON_BUSINESS_UNIT.Mortgage,
      'po-button--blocks': businessUnit === BUTTON_BUSINESS_UNIT.Blocks,
      'po-button--newsletter': businessUnit === BUTTON_BUSINESS_UNIT.Newsletter,
      'po-bottom-navMortgage':
        businessUnit === BUTTON_BUSINESS_UNIT.NavMortgage,
      'po-button--subscribeMortgage':
        businessUnit === BUTTON_BUSINESS_UNIT.SubscribeMortgage,
      'po-button--profileMortgage':
        businessUnit === BUTTON_BUSINESS_UNIT.ProfileMortgage
    }"
    [type]="type"
    [disabled]="disabled || loading"
    (click)="clicked.emit($event)"
  >
    <div class="relative flex items-center gap-x-2">
      @if (loading) {
        <po-button-spinner
          class="block"
          [ngClass]="{
            'h-4 w-4': size === BUTTON_SIZE.Small,
            'h-5 w-5': size === BUTTON_SIZE.Medium || size === BUTTON_SIZE.Large
          }"
        />
      } @else {
        @if (prefixIcon) {
          <aw-icon
            class="md:flex md:items-center"
            [ngClass]="{
              'h-4 w-4': size === BUTTON_SIZE.Small,
              'h-6 w-6':
                size === BUTTON_SIZE.Medium || size === BUTTON_SIZE.Large
            }"
            [icon]="prefixIcon"
          />
        }

        @if (icon) {
          <aw-icon
            class="md:flex md:items-center"
            [ngClass]="{
              'h-4 w-4': size === BUTTON_SIZE.Small,
              'h-6 w-6':
                size === BUTTON_SIZE.Medium || size === BUTTON_SIZE.Large
            }"
            [icon]="icon"
          />
        } @else {
          <span class="whitespace-nowrap">
            <ng-content />
          </span>
        }

        @if (suffixIcon) {
          <aw-icon
            class="md:flex md:items-center"
            [ngClass]="{
              'h-4 w-4': size === BUTTON_SIZE.Small,
              'h-5 w-5':
                size === BUTTON_SIZE.Medium || size === BUTTON_SIZE.Large
            }"
            [icon]="suffixIcon"
          />
        }
      }
    </div>
  </button>
</ng-template>
